import { CommercialControlActionTypes } from "../Actions/actionTypes";

export const initialCommercialControlState = {
    usageSnapshot: null,
    usageByType: {},
    customCriteria: {},
    capabilities: {},
    plan: null,
    usageIdentityKey: null,
    loadingUsageIdentityKey: null,
    lastDecision: null,
    activeReservationId: null,
    isCheckingGate: false,
    isLoadingUsage: false,
    gateModalOpen: false,
    partialAnalysisDecision: null,
    lastCommercialError: null,
};

export const commercialControlReducer = (
    state = initialCommercialControlState,
    action
) => {
    switch (action.type) {
        case CommercialControlActionTypes.COMMERCIAL_RESET:
            return { ...initialCommercialControlState };

        case CommercialControlActionTypes.COMMERCIAL_USAGE_REQUEST: {
            const requestIdentityKey = action.meta?.identityKey || null;
            const shouldClearStaleUsage =
                requestIdentityKey &&
                state.usageSnapshot &&
                state.usageIdentityKey !== requestIdentityKey;

            return {
                ...(shouldClearStaleUsage ? initialCommercialControlState : state),
                isLoadingUsage: true,
                loadingUsageIdentityKey: requestIdentityKey,
                lastCommercialError: null,
            };
        }

        case CommercialControlActionTypes.COMMERCIAL_USAGE_SUCCESS: {
            const usageSnapshot = action.payload || null;
            const responseIdentityKey = action.meta?.identityKey || null;
            return {
                ...state,
                usageSnapshot,
                usageByType: usageSnapshot?.usage || {},
                customCriteria: usageSnapshot?.custom_criteria || {},
                capabilities: usageSnapshot?.capabilities || {},
                plan: usageSnapshot?.plan || null,
                usageIdentityKey: responseIdentityKey,
                loadingUsageIdentityKey: null,
                isLoadingUsage: false,
                lastCommercialError: null,
            };
        }

        case CommercialControlActionTypes.COMMERCIAL_USAGE_FAILURE:
            return {
                ...state,
                isLoadingUsage: false,
                loadingUsageIdentityKey: null,
                lastCommercialError: action.payload || null,
            };

        case CommercialControlActionTypes.COMMERCIAL_PREFLIGHT_REQUEST:
            return {
                ...state,
                isCheckingGate: true,
                lastCommercialError: null,
            };

        case CommercialControlActionTypes.COMMERCIAL_PREFLIGHT_SUCCESS:
            return {
                ...state,
                lastDecision: action.payload || null,
                isCheckingGate: false,
                lastCommercialError: null,
            };

        case CommercialControlActionTypes.COMMERCIAL_PREFLIGHT_FAILURE:
            return {
                ...state,
                isCheckingGate: false,
                lastCommercialError: action.payload || null,
            };

        case CommercialControlActionTypes.COMMERCIAL_SET_ACTIVE_RESERVATION:
            return {
                ...state,
                activeReservationId: action.payload || null,
            };

        case CommercialControlActionTypes.COMMERCIAL_CLEAR_ACTIVE_RESERVATION:
            return {
                ...state,
                activeReservationId: null,
            };

        case CommercialControlActionTypes.COMMERCIAL_OPEN_GATE_MODAL:
            return {
                ...state,
                gateModalOpen: true,
                lastDecision: action.payload || state.lastDecision,
            };

        case CommercialControlActionTypes.COMMERCIAL_CLOSE_GATE_MODAL:
            return {
                ...state,
                gateModalOpen: false,
            };

        case CommercialControlActionTypes.COMMERCIAL_SET_PARTIAL_ANALYSIS_DECISION:
            return {
                ...state,
                partialAnalysisDecision: action.payload || null,
            };

        case CommercialControlActionTypes.COMMERCIAL_CLEAR_PARTIAL_ANALYSIS_DECISION:
            return {
                ...state,
                partialAnalysisDecision: null,
            };

        default:
            return state;
    }
};
